import i18n from 'i18next';
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

// import translate json
import template from './translations/template.json';
import translation from './translations/translation.json';
import menu from './translations/menu.json';
import dashboard from './translations/dashboard.json';
import users from './translations/users.json';
import workspaces from './translations/workspaces.json';
import details from "./translations/workspaceDetails.json"
import addressTypes from "./translations/addressTypes.json"
import contacts from "./translations/contacts.json"
import clients from "./translations/clients.json"
import countries from "./translations/countries.json"
import consents from "./translations/consents.json"
import employeeDocumentType from "./translations/employee-document-type.json"
import location from "./translations/location.json";
import drivers from "./translations/drivers.json"
import vehicles from "./translations/vehicles.json"
import devices from "./translations/devices.json";
import customers from "./translations/customers.json";
import telemetry from "./translations/telemetry.json";
import employeeDocument from "./translations/employeeDocument.json";
import userPOI from "./translations/userPOI.json";
import statistics from "./translations/statistics.json";
import ecoDriving from "./translations/ecodriving.json";
import invoices from "./translations/invoices.json";
import tariff from "./translations/tariff.json";
import payment from "./translations/payment.json";

const resources = {
    pl: {
        template: {...template, ...menu},
        translation: translation,
        dashboard: dashboard,
        users,
        workspaces,
        details,
        contacts,
        addressTypes,
        clients,
        countries,
        consents,
        employeeDocumentType,
        location,
        devices,
        customers,
        drivers,
        vehicles,
        telemetry,
        employeeDocument,
        userPOI,
        statistics,
        ecoDriving,
        invoices,
        tariff,
        payment
    }
};

const options = {
    order: ['localStorage', 'navigator', 'htmlTag'],
    lookupLocalStorage: 'language',
    caches: ['localStorage'],
    htmlTag: document.documentElement
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        detection: options,
        resources,
        //lng: "pl",
        keySeparator: false,
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
